<div class="ag-custom-no-rows-overlay">
  <img src="/assets/images/lg-cross-reference.svg" width="56" height="56" alt="" />
  <ra-ui-empty-state
    id="emptyStateComponent"
    [title]="params.title ?? ''"
    [message]="params.content ?? ''"
  ></ra-ui-empty-state>
</div>
